<template>
  <div
    class="oms-comment-cell"
    :class="{
      'oms-comment-cell--has-comment': hasComment,
      'oms-comment-cell--empty': !hasComment,
    }"
  >
    <v-tooltip
      v-if="hasComment"
      left
      class="milestone"
      content-class="tooltip-op-comment"
      color="orange"
    >
      <template slot="activator">
        <span class="oms-comment-cell__text" :title="fullText">
          {{ fullText }}
        </span>
      </template>
      <span class="tooltip oms-comment-cell__tooltip">
        {{ fullText }}
      </span>
    </v-tooltip>
    <slot name="action" />
  </div>
</template>

<script>
export default {
  name: "CommentCell",
  props: {
    comment: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    fullText() {
      return this.comment == null ? "" : String(this.comment).trim();
    },
    hasComment() {
      return this.fullText.length > 0;
    },
    previewText() {
      if (!this.hasComment) {
        return "";
      }

      return this.fullText.split(/\r?\n/)[0];
    },
  },
};
</script>
